var typography = {
  fonts: {
    body: 'Nunito Sans, sans-serif',
    heading: 'Nunito Sans, sans-serif',
    mono: 'Menlo, monospace'
  },
  fontSizes: {
    xs: '0.75rem',
    // 12px
    sm: '0.875rem',
    // 14px
    md: '1rem',
    // 16px
    lg: '1.125rem',
    // 18px
    xl: '1.25rem',
    // 20px
    '2xl': '1.375rem',
    // 22px
    '3xl': '1.5rem',
    // 24px
    '4xl': '1.875rem',
    // 30px
    '5xl': '2rem',
    // 32px
    '6xl': '2.25rem',
    // 36px
    '7xl': '3rem',
    // 48px
    '8xl': '3.75rem',
    // 60px
    '9xl': '4.5rem' // 72px

  }
};
export default typography;
//# sourceMappingURL=typography.js.map